import { TestIdDomain } from 'constants/testIds';

export const LoanClosingCDSTestIds = {
  LOAN_CLOSING_CDS: `${TestIdDomain.LOAN_CLOSING}.wrapper`,
};
